import React, { useContext, useState, useEffect } from 'react';
import { PaystackButton } from 'react-paystack';
import { useNavigate, Link } from 'react-router-dom';
import emailjs from 'emailjs-com';
import { CartContext } from './contexts/CartContext';
// import './css/CheckoutPage.css';
import { Country, State } from 'country-state-city';
import Select from 'react-select';
import Footer from './includes/Footer';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@mui/material';
import './css/CheckoutPage.css'
import PageTitle from './includes/PageTitle';

import { db } from './../firebase/firebaseConfig';
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

import currency from 'currency.js';


export default function CheckoutPage() {
  


  const { cart, cartSummary, cartItems } = useContext(CartContext);
  const navigate = useNavigate();
  
  // ***** REDIRECTS TO "/products" if there is no product in the cart
 
  useEffect(() => {
    if (cart.length === 0) {
      navigate('/products');
    }
  }, [cartItems, navigate]);



  const publicKey = 'pk_test_1a49c590ccc85fa055fd80e5fd91d6edc1e42d1a'; // Replace with your Paystack public key
  const [email, setEmail] = useState(''); // Customer email
  const [firstname, setFirstName] = useState(''); // Customer name
  const [lastname, setLastName] = useState(''); // Customer name
  const [phone, setPhone] = useState(''); // Customer phone number
  const [delivery_address, setDeliveryAddress] = useState(''); // Customer Delivery Address
  const [note, setNote] = useState('');
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [states, setStates] = useState([]);
  const [deliveryFee, setDeliveryFee] = useState(0); // Default delivery fee for Nigeria
  


  


  // ****** FOR EMAIL FUNC**************//
  // Replace with your EmailJS public key
  const emailJsPublicKey = 'UBoYCMQqKGppu2QeN';
  // Replace with your EmailJS service ID
  const emailJsServiceId = 'service_izaffax';
  // Replace with your EmailJS template ID
  const emailJsTemplateId = 'template_scaxw8z';

  const sendEmail = () => {
    const templateParams = {
      user_name: `${firstname} ${lastname}`,
      user_email: email,
      total_amount: cartSummary.subTotal.toFixed(2),
      order_details: cart.map(item => `${item.name} x ${item.quantity} - $${item.price * item.quantity}`).join(', '),
    };

    emailjs.send(emailJsServiceId, emailJsTemplateId, templateParams, emailJsPublicKey)
      .then((response) => {
        console.log('Email sent successfully!', response.status, response.text);
      }, (error) => {
        console.log('Failed to send email.', error);
      });
  }; 

 

  // ************* END OF EMAIL FUNC ***************

  


  //*************** FETCHING OF COUNTRIES AND STATES */
  // Handling the country selections 
 

  const countries = Country.getAllCountries().map((country) => ({
    value: country.isoCode,
    label: country.name,
  }));

  const handleCountryChange = (selectedOption) => {
    setSelectedCountry(selectedOption);
    const countryStates = State.getStatesOfCountry(selectedOption.value).map((state) => ({
      value: state.isoCode,
      label: state.name,
    }));
    setStates(countryStates);
    if (selectedOption.label !== "Nigeria") {
      setDeliveryFee(20*1600); // Set delivery fee to $80 for countries other than Nigeria
    } else {
      setDeliveryFee(4000); // Set delivery fee to ₦3500 for Nigeria
    }
  };

  useEffect(() => {
    console.log("Selected Country: ", selectedCountry);
    console.log("Delivery Fee: ", deliveryFee);
  }, [selectedCountry, deliveryFee]);

  

  //************ PAYSTACK FUNC */
  const calculatePaystackFee = (amount) => {
    const feePercentage = 3.9;
    const flatFee = 100;
    return ((amount * feePercentage) / 100) + flatFee;
  };

  const subTotal = cartSummary.subTotal;
  const totalBeforePaystackFee = subTotal + deliveryFee;
  const paystackFee = calculatePaystackFee(totalBeforePaystackFee);
  const total = totalBeforePaystackFee + paystackFee;
  const [open, setOpen] = useState(false);

  const amount = (cartSummary.subTotal + deliveryFee) * 100 ;

  const [selectedState, setSelectedState] = useState(null); // New state for selected state

// Function to handle the selection of a state
const handleStateChange = (selectedOption) => {
  setSelectedState(selectedOption); // Save the selected state
};

  // Function to save order details to the database
  const saveOrderDetails = async () => {
    const orderData = {
      firstname,
      lastname,
      email,
      phone,
      delivery_address,
      selectedCountry: selectedCountry ? selectedCountry.label : '', // Save only the label
      state: selectedState ? selectedState.label : '', // Save only the selected state's label
      note,
      cart,
      total: cartSummary.subTotal + deliveryFee,
      orderDate: serverTimestamp(), // Use Firestore timestamp
  };

  try {
    // Save orderData to the database
    const orderRef = await addDoc(collection(db, "Orders"), orderData);
    console.log("Order saved with ID: ", orderRef.id); // You can remove or adjust this line based on your needs
  } catch (error) {
    console.error("Error saving order: ", error);
  }

    console.log('Order Data:', orderData);
  };

  const handleSuccess = () => {
    saveOrderDetails();
    sendEmail();
    navigate('/order-successful');
  };
  const handleClose = () => {
    setOpen(true);
  };

  const handlePopupClose = () => {
    setOpen(false);
  };

  const componentProps = {
    email,
    amount,
    publicKey,
    text: 'Pay With Paystack',
    onSuccess: handleSuccess,
    onClose: handleClose,
  };

  const handleWhatsAppRedirect = () => {
    // Construct the message for WhatsApp
    let message = `Hello, I would like to place an order. 
    Customer Info:
    Full Name: ${firstname} ${lastname}
    Email: ${email}
    Phone: ${phone}
    Delivery Address: ${delivery_address}
    Country: ${selectedCountry ? selectedCountry.label : ''}
    State: ${selectedState ? selectedState.label : ''}
    Note: ${note}
    
    Order Details:\n`;
  
    // Loop through cartItems to add product details
    cart.forEach((item) => {
      message += `\nProduct Name: ${item.name}
      Price: ₦${item.price}
      Quantity: ${item.quantity}
      Color: ${item.color || 'N/A'}
      Size: ${item.size || 'N/A'}
      Product ID: #${item.id}\n`;
    });
  
    // Include total price and delivery fee
    message += `\nTotal: ₦${cartSummary.subTotal + deliveryFee}\n
    Delivery Fee: ₦${deliveryFee}
    Total: ₦${cartSummary.subTotal + deliveryFee}`

  
    // URL encode the message
    const encodedMessage = encodeURIComponent(message);
  
    // WhatsApp link (replace with your number)
    const whatsappUrl = `https://wa.me/+2348157081943?text=${encodedMessage}`;
  
    // Open WhatsApp link in a new tab
    window.open(whatsappUrl, '_blank');
  };
  


  return (
    <>
    <PageTitle title="Checkout - ALMOSTINVISIBLE" />
    <div className="checkout-container container" style={{marginTop: "25vh", marginBottom: "10vh"}}>
      <div className="d-flex justify-content-between">
          <h1 className="checkout-title unbounded">Checkout</h1>
          <a href="#summary" className='black-button target-summary'>
              Order Summary
          </a>
      </div>
      
      
      <div className="checkout-details">
        <div class="row g-5">
          {/** Contact form */}
          <div className="checkout-form col-lg-7">
            <div className="d-flex justify-content-between">
              <h5 className='nunito-2 fw-bold'>Contact</h5>

              <Link to="/sign-in" className='black-link nunito-2 fw-bold'>
                Log in
              </Link>
            </div>
            <hr />
            
            <div className="row">
              <label htmlFor="" className="nunito-2 fw-bold">
                Fullname*
              </label>
              <div className="col-6">
                <input
                  type="text"
                  placeholder="Enter your firstname"
                  value={firstname}
                  onChange={(e) => setFirstName(e.target.value)}
                  className='black-bordered-input'
                  required
                />
              </div>
              <div className="col-6">
                <input
                  type="text"
                  placeholder="Enter your lastname"
                  value={lastname}
                  onChange={(e) => setLastName(e.target.value)}
                  className='black-bordered-input'
                  required
                />
              </div>
            </div>
            <br />
            
            <div>
              <label htmlFor="" className="nunito-2 fw-bold">
                Email Address*
              </label>
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className='black-bordered-input'
                required
              />
            </div>

            <br />

            <div>
              <label htmlFor="" className="nunito-2 fw-bold">
                Phone Number* <i className='fw-light'>(Incase we want to contact you)</i>
              </label>
              <input
                type="tel"
                placeholder="Enter your phone number"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                className='black-bordered-input'
                required
              />
            </div>
            
            <br />
            <h4 className="unbounded">
              Delivery
            </h4>
            <hr />
            <div>
              <label htmlFor="" className="nunito-2 fw-bold">
                Country
              </label>
              <Select
                options={countries}
                value={selectedCountry}
                onChange={handleCountryChange}
                placeholder="Select a country"
                required
              />
              <br />
              {selectedCountry && (
                <div>
                    <label htmlFor="" className="nunito-2 fw-bold">
                      State
                    </label>
                    <Select
                      options={states}
                      placeholder="Select a state"
                      onChange={handleStateChange} // Capture the selected state
                    />
                    <br />
                </div>
                
              )}
            </div>


            <div id='summary'>
              <label htmlFor="" className="nunito-2 fw-bold">
                Address
              </label>
              <input
                type="text"
                placeholder="Your delivery address"
                value={delivery_address}
                onChange={(e) => setDeliveryAddress(e.target.value)}
                className='black-bordered-input'
                required
              />
            </div>
            <br />
            <div className="cart-note">
                <label htmlFor="" className="nunito-2 fw-bold">
                  Leave a note
                </label>
                <input type="text" value={note} onChange={(e) => setNote(e.target.value)} placeholder="Leave a note with your order" />
            </div>

            

            
           
          </div>

          <div className="checkout-summary col-lg-5"  style={{ position: "sticky", top: "20vh"}}>
            <h5 className="nunito-2 fw-bold">Order Summary</h5>

              {cart.map((item, index) => (
                <div key={`${item.id}-${item.color}-${item.size}`} style={{listStyle:"none", borderBottom: "1px solid #ecedec"}}>
                  <p className='unbounded'>
                    {index + 1}. {item.name}
                  </p>
                  <div className="d-flex justify-content-between">
                      <img src={item.images[0]} width={80} height={60} alt="" srcset="" />

                      <div className="d-flex flex-column fw-bold">
                          <p className="nunito-2">
                            X{item.quantity}
                          </p>
                          <p className="fw-bold nunito-2">
                            ₦{item.price * item.quantity}
                          </p>
                      </div>
                  </div> 
                </div>

              ))}
           
              <div>
                <div className="d-flex justify-content-between mt-3">
                  <p className="fw-bold nunito-2">
                    Delivery Fee
                  </p>
                  <p className="fw-bold nunito-2">
                    {selectedCountry && selectedCountry.label !== "Nigeria" ? `₦${deliveryFee}` : `₦${deliveryFee}`}
                  </p>
                </div>

                {/*
                <div className="d-flex justify-content-between mt-3">
                  <p className="fw-bold nunito-2">
                    Paystack Fee
                  </p>
                  <p className="fw-bold nunito-2">
                    ₦{paystackFee.toFixed(2)}
                  </p>
            </div>*/}
              </div>
              


              <hr />

              <div className="d-flex justify-content-between">
                <h5 className="unbounded">
                  Total
                </h5>
                <h5 className="unbounded">
                  {selectedCountry && selectedCountry.label !== "Nigeria" ? `₦${(cartSummary.subTotal + deliveryFee).toFixed(2)}` : `₦${(cartSummary.subTotal + deliveryFee).toFixed(2)}`}
                </h5>
              </div>

           
          </div>
        </div>

        <div className="col-lg-7">
            <br />
            {/*
            <div className='my-2'>
                  <svg stroke="currentColor" className='mx-2' fill="currentColor" stroke-width="0" viewBox="0 0 576 512" height="1.8em" width="1.8em" xmlns="http://www.w3.org/2000/svg"><path d="M470.1 231.3s7.6 37.2 9.3 45H446c3.3-8.9 16-43.5 16-43.5-.2.3 3.3-9.1 5.3-14.9l2.8 13.4zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM152.5 331.2L215.7 176h-42.5l-39.3 106-4.3-21.5-14-71.4c-2.3-9.9-9.4-12.7-18.2-13.1H32.7l-.7 3.1c15.8 4 29.9 9.8 42.2 17.1l35.8 135h42.5zm94.4.2L272.1 176h-40.2l-25.1 155.4h40.1zm139.9-50.8c.2-17.7-10.6-31.2-33.7-42.3-14.1-7.1-22.7-11.9-22.7-19.2.2-6.6 7.3-13.4 23.1-13.4 13.1-.3 22.7 2.8 29.9 5.9l3.6 1.7 5.5-33.6c-7.9-3.1-20.5-6.6-36-6.6-39.7 0-67.6 21.2-67.8 51.4-.3 22.3 20 34.7 35.2 42.2 15.5 7.6 20.8 12.6 20.8 19.3-.2 10.4-12.6 15.2-24.1 15.2-16 0-24.6-2.5-37.7-8.3l-5.3-2.5-5.6 34.9c9.4 4.3 26.8 8.1 44.8 8.3 42.2.1 69.7-20.8 70-53zM528 331.4L495.6 176h-31.1c-9.6 0-16.9 2.8-21 12.9l-59.7 142.5H426s6.9-19.2 8.4-23.3H486c1.2 5.5 4.8 23.3 4.8 23.3H528z"></path></svg>
                  <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 576 512" height="1.8em" width="1.8em" xmlns="http://www.w3.org/2000/svg"><path d="M482.9 410.3c0 6.8-4.6 11.7-11.2 11.7-6.8 0-11.2-5.2-11.2-11.7 0-6.5 4.4-11.7 11.2-11.7 6.6 0 11.2 5.2 11.2 11.7zm-310.8-11.7c-7.1 0-11.2 5.2-11.2 11.7 0 6.5 4.1 11.7 11.2 11.7 6.5 0 10.9-4.9 10.9-11.7-.1-6.5-4.4-11.7-10.9-11.7zm117.5-.3c-5.4 0-8.7 3.5-9.5 8.7h19.1c-.9-5.7-4.4-8.7-9.6-8.7zm107.8.3c-6.8 0-10.9 5.2-10.9 11.7 0 6.5 4.1 11.7 10.9 11.7 6.8 0 11.2-4.9 11.2-11.7 0-6.5-4.4-11.7-11.2-11.7zm105.9 26.1c0 .3.3.5.3 1.1 0 .3-.3.5-.3 1.1-.3.3-.3.5-.5.8-.3.3-.5.5-1.1.5-.3.3-.5.3-1.1.3-.3 0-.5 0-1.1-.3-.3 0-.5-.3-.8-.5-.3-.3-.5-.5-.5-.8-.3-.5-.3-.8-.3-1.1 0-.5 0-.8.3-1.1 0-.5.3-.8.5-1.1.3-.3.5-.3.8-.5.5-.3.8-.3 1.1-.3.5 0 .8 0 1.1.3.5.3.8.3 1.1.5s.2.6.5 1.1zm-2.2 1.4c.5 0 .5-.3.8-.3.3-.3.3-.5.3-.8 0-.3 0-.5-.3-.8-.3 0-.5-.3-1.1-.3h-1.6v3.5h.8V426h.3l1.1 1.4h.8l-1.1-1.3zM576 81v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V81c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM64 220.6c0 76.5 62.1 138.5 138.5 138.5 27.2 0 53.9-8.2 76.5-23.1-72.9-59.3-72.4-171.2 0-230.5-22.6-15-49.3-23.1-76.5-23.1-76.4-.1-138.5 62-138.5 138.2zm224 108.8c70.5-55 70.2-162.2 0-217.5-70.2 55.3-70.5 162.6 0 217.5zm-142.3 76.3c0-8.7-5.7-14.4-14.7-14.7-4.6 0-9.5 1.4-12.8 6.5-2.4-4.1-6.5-6.5-12.2-6.5-3.8 0-7.6 1.4-10.6 5.4V392h-8.2v36.7h8.2c0-18.9-2.5-30.2 9-30.2 10.2 0 8.2 10.2 8.2 30.2h7.9c0-18.3-2.5-30.2 9-30.2 10.2 0 8.2 10 8.2 30.2h8.2v-23zm44.9-13.7h-7.9v4.4c-2.7-3.3-6.5-5.4-11.7-5.4-10.3 0-18.2 8.2-18.2 19.3 0 11.2 7.9 19.3 18.2 19.3 5.2 0 9-1.9 11.7-5.4v4.6h7.9V392zm40.5 25.6c0-15-22.9-8.2-22.9-15.2 0-5.7 11.9-4.8 18.5-1.1l3.3-6.5c-9.4-6.1-30.2-6-30.2 8.2 0 14.3 22.9 8.3 22.9 15 0 6.3-13.5 5.8-20.7.8l-3.5 6.3c11.2 7.6 32.6 6 32.6-7.5zm35.4 9.3l-2.2-6.8c-3.8 2.1-12.2 4.4-12.2-4.1v-16.6h13.1V392h-13.1v-11.2h-8.2V392h-7.6v7.3h7.6V416c0 17.6 17.3 14.4 22.6 10.9zm13.3-13.4h27.5c0-16.2-7.4-22.6-17.4-22.6-10.6 0-18.2 7.9-18.2 19.3 0 20.5 22.6 23.9 33.8 14.2l-3.8-6c-7.8 6.4-19.6 5.8-21.9-4.9zm59.1-21.5c-4.6-2-11.6-1.8-15.2 4.4V392h-8.2v36.7h8.2V408c0-11.6 9.5-10.1 12.8-8.4l2.4-7.6zm10.6 18.3c0-11.4 11.6-15.1 20.7-8.4l3.8-6.5c-11.6-9.1-32.7-4.1-32.7 15 0 19.8 22.4 23.8 32.7 15l-3.8-6.5c-9.2 6.5-20.7 2.6-20.7-8.6zm66.7-18.3H408v4.4c-8.3-11-29.9-4.8-29.9 13.9 0 19.2 22.4 24.7 29.9 13.9v4.6h8.2V392zm33.7 0c-2.4-1.2-11-2.9-15.2 4.4V392h-7.9v36.7h7.9V408c0-11 9-10.3 12.8-8.4l2.4-7.6zm40.3-14.9h-7.9v19.3c-8.2-10.9-29.9-5.1-29.9 13.9 0 19.4 22.5 24.6 29.9 13.9v4.6h7.9v-51.7zm7.6-75.1v4.6h.8V302h1.9v-.8h-4.6v.8h1.9zm6.6 123.8c0-.5 0-1.1-.3-1.6-.3-.3-.5-.8-.8-1.1-.3-.3-.8-.5-1.1-.8-.5 0-1.1-.3-1.6-.3-.3 0-.8.3-1.4.3-.5.3-.8.5-1.1.8-.5.3-.8.8-.8 1.1-.3.5-.3 1.1-.3 1.6 0 .3 0 .8.3 1.4 0 .3.3.8.8 1.1.3.3.5.5 1.1.8.5.3 1.1.3 1.4.3.5 0 1.1 0 1.6-.3.3-.3.8-.5 1.1-.8.3-.3.5-.8.8-1.1.3-.6.3-1.1.3-1.4zm3.2-124.7h-1.4l-1.6 3.5-1.6-3.5h-1.4v5.4h.8v-4.1l1.6 3.5h1.1l1.4-3.5v4.1h1.1v-5.4zm4.4-80.5c0-76.2-62.1-138.3-138.5-138.3-27.2 0-53.9 8.2-76.5 23.1 72.1 59.3 73.2 171.5 0 230.5 22.6 15 49.5 23.1 76.5 23.1 76.4.1 138.5-61.9 138.5-138.4z"></path></svg>
                  <svg className='mx-2' viewBox="0 -139.5 750 750" height="1.8em" width="1.8em" version="1.1" xmlns="http://www.w3.org/2000/svg">
                        
                        <defs>

                        </defs>
                        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <path d="M269.059229,191.663172 C258.078649,139.442552 211.749588,100.23653 156.26347,100.23653 C92.6052133,100.23653 41,151.841743 41,215.5 C41,279.158257 92.6052133,330.76347 156.26347,330.76347 C193.534181,330.76347 226.673251,313.073811 247.742716,285.632458 C259.456497,304.963447 280.833444,312.59491 303.73687,312.59491 C327.79517,312.59491 344.97881,305.72097 344.97881,305.72097 L341.54148,278.22677 C341.54148,278.22677 324.35783,283.3869 307.17405,283.3869 C272.80539,283.3869 271.08739,257.60566 271.08739,257.60566 L348.41613,257.60566 C351.852,236.98469 348.41613,185.4322 296.86364,185.4322 C286.541297,185.4322 277.149009,187.602294 269.059229,191.663172 Z M40,-1.42108547e-14 L710,-1.42108547e-14 C732.09139,-1.82689772e-14 750,17.90861 750,40 L750,431 C750,453.09139 732.09139,471 710,471 L40,471 C17.90861,471 -1.15054397e-14,453.09139 -1.42108547e-14,431 L-1.42108547e-14,40 C-1.69162697e-14,17.90861 17.90861,-1.01527322e-14 40,-1.42108547e-14 Z M156.26347,264.87251 C182.04325,206.43174 200.94837,151.84021 200.94837,151.84021 L240.47311,151.84021 C240.47311,151.84021 216.41624,221.91184 171.73134,309.54065 L140.79561,309.54065 C96.11071,221.91184 72.05384,151.84021 72.05384,151.84021 L111.57857,151.84021 C111.57857,151.84021 130.48369,206.43174 156.26347,264.87251 Z M708.04515,257.60566 C711.48248,236.98469 708.04515,185.4322 656.4926,185.4322 C622.12375,185.4322 598.06688,209.48978 598.06688,247.29525 C598.06688,295.41041 628.99845,312.59491 663.36588,312.59491 C687.42418,312.59491 704.60925,305.72097 704.60925,305.72097 L701.17192,278.22677 C701.17192,278.22677 683.98685,283.3869 666.80307,283.3869 C632.43441,283.3869 630.71641,257.60566 630.71641,257.60566 L708.04515,257.60566 Z M654.77471,209.48978 C677.11363,209.48978 678.83158,233.54736 678.83158,233.54736 L630.71641,233.54736 C630.71641,233.54736 632.43436,209.48978 654.77471,209.48978 Z M442.3337,216.74823 L447.48884,189.25332 C447.48884,189.25332 407.67636,177.17202 375.31538,199.56388 L375.31538,309.54067 L409.68552,309.54067 L409.68281,220.18485 C423.42925,209.87443 442.3337,216.74823 442.3337,216.74823 Z M295.14426,209.48978 C272.80534,209.48978 271.08739,233.54736 271.08739,233.54736 L319.20256,233.54736 C319.20256,233.54736 317.4846,209.48978 295.14426,209.48978 Z M525.80355,268.32373 C515.12048,242.341853 506.501709,215.55843 500.02729,188.22223 L465.66129,188.22677 C465.66129,188.22677 482.845,254.57171 512.05993,309.5462 L539.54717,309.5462 C568.76212,254.57171 585.94581,188.239 585.94581,188.239 L551.57981,188.239 C545.103957,215.569341 536.48521,242.34708 525.80355,268.32373 Z" id="Combined-Shape" fill="#393939" fill-rule="nonzero">

                            </path>
                        </g>
                  </svg>
                  <svg stroke="currentColor" fill="currentColor" stroke-width="0" role="img" viewBox="0 0 24 24" height="1.8em" width="1.8em" xmlns="http://www.w3.org/2000/svg"><title></title><path d="M16.015 14.378c0-.32-.135-.496-.344-.622-.21-.12-.464-.135-.81-.135h-1.543v2.82h.675v-1.027h.72c.24 0 .39.024.478.125.12.13.104.38.104.55v.35h.66v-.555c-.002-.25-.017-.376-.108-.516-.06-.08-.18-.18-.33-.234l.02-.008c.18-.072.48-.297.48-.747zm-.87.407l-.028-.002c-.09.053-.195.058-.33.058h-.81v-.63h.824c.12 0 .24 0 .33.05.098.048.156.147.15.255 0 .12-.045.215-.134.27zM20.297 15.837H19v.6h1.304c.676 0 1.05-.278 1.05-.884 0-.28-.066-.448-.187-.582-.153-.133-.392-.193-.73-.207l-.376-.015c-.104 0-.18 0-.255-.03-.09-.03-.15-.105-.15-.21 0-.09.017-.166.09-.21.083-.046.177-.066.272-.06h1.23v-.602h-1.35c-.704 0-.958.437-.958.84 0 .9.776.855 1.407.87.104 0 .18.015.225.06.046.03.082.106.082.18 0 .077-.035.15-.08.18-.06.053-.15.07-.277.07zM0 0v10.096L.81 8.22h1.75l.225.464V8.22h2.043l.45 1.02.437-1.013h6.502c.295 0 .56.057.756.236v-.23h1.787v.23c.307-.17.686-.23 1.12-.23h2.606l.24.466v-.466h1.918l.254.465v-.466h1.858v3.948H20.87l-.36-.6v.585h-2.353l-.256-.63h-.583l-.27.614h-1.213c-.48 0-.84-.104-1.08-.24v.24h-2.89v-.884c0-.12-.03-.12-.105-.135h-.105v1.036H6.067v-.48l-.21.48H4.69l-.202-.48v.465H2.235l-.256-.624H1.4l-.256.624H0V24h23.786v-7.108c-.27.135-.613.18-.973.18H21.09v-.255c-.21.165-.57.255-.914.255H14.71v-.9c0-.12-.018-.12-.12-.12h-.075v1.022h-1.8v-1.066c-.298.136-.643.15-.928.136h-.214v.915h-2.18l-.54-.617-.57.6H4.742v-3.93h3.61l.518.602.554-.6h2.412c.28 0 .74.03.942.225v-.24h2.177c.202 0 .644.045.903.225v-.24h3.265v.24c.163-.164.508-.24.803-.24h1.89v.24c.194-.15.464-.24.84-.24h1.176V0H0zM21.156 14.955c.004.005.006.012.01.016.01.01.024.01.032.02l-.042-.035zM23.828 13.082h.065v.555h-.065zM23.865 15.03v-.005c-.03-.025-.046-.048-.075-.07-.15-.153-.39-.215-.764-.225l-.36-.012c-.12 0-.194-.007-.27-.03-.09-.03-.15-.105-.15-.21 0-.09.03-.16.09-.204.076-.045.15-.05.27-.05h1.223v-.588h-1.283c-.69 0-.96.437-.96.84 0 .9.78.855 1.41.87.104 0 .18.015.224.06.046.03.076.106.076.18 0 .07-.034.138-.09.18-.045.056-.136.07-.27.07h-1.288v.605h1.287c.42 0 .734-.118.9-.36h.03c.09-.134.135-.3.135-.523 0-.24-.045-.39-.135-.526zM18.597 14.208v-.583h-2.235V16.458h2.235v-.585h-1.57v-.57h1.533v-.584h-1.532v-.51M13.51 8.787h.685V11.6h-.684zM13.126 9.543l-.007.006c0-.314-.13-.5-.34-.624-.217-.125-.47-.135-.81-.135H10.43v2.82h.674v-1.034h.72c.24 0 .39.03.487.12.122.136.107.378.107.548v.354h.677v-.553c0-.25-.016-.375-.11-.516-.09-.107-.202-.19-.33-.237.172-.07.472-.3.472-.75zm-.855.396h-.015c-.09.054-.195.056-.33.056H11.1v-.623h.825c.12 0 .24.004.33.05.09.04.15.128.15.25s-.047.22-.134.266zM15.92 9.373h.632v-.6h-.644c-.464 0-.804.105-1.02.33-.286.3-.362.69-.362 1.11 0 .512.123.833.36 1.074.232.238.645.31.97.31h.78l.255-.627h1.39l.262.627h1.36v-2.11l1.272 2.11h.95l.002.002V8.786h-.684v1.963l-1.18-1.96h-1.02V11.4L18.11 8.744h-1.004l-.943 2.22h-.3c-.177 0-.362-.03-.468-.134-.125-.15-.186-.36-.186-.662 0-.285.08-.51.194-.63.133-.135.272-.165.516-.165zm1.668-.108l.464 1.118v.002h-.93l.466-1.12zM2.38 10.97l.254.628H4V9.393l.972 2.205h.584l.973-2.202.015 2.202h.69v-2.81H6.118l-.807 1.904-.876-1.905H3.343v2.663L2.205 8.787h-.997L.01 11.597h.72l.26-.626h1.39zm-.688-1.705l.46 1.118-.003.002h-.915l.457-1.12zM11.856 13.62H9.714l-.85.923-.825-.922H5.346v2.82H8l.855-.932.824.93h1.302v-.94h.838c.6 0 1.17-.164 1.17-.945l-.006-.003c0-.78-.598-.93-1.128-.93zM7.67 15.853l-.014-.002H6.02v-.557h1.47v-.574H6.02v-.51H7.7l.733.82-.764.824zm2.642.33l-1.03-1.147 1.03-1.108v2.253zm1.553-1.258h-.885v-.717h.885c.24 0 .42.098.42.344 0 .243-.15.372-.42.372zM9.967 9.373v-.586H7.73V11.6h2.237v-.58H8.4v-.564h1.527V9.88H8.4v-.507"></path></svg>
              </div>*/}
            <div className="checkout-payment d-flex justify-content-between align-content-center" >
              {/*<PaystackButton {...componentProps} className=' black-button ' />*/}
              <button
                  className="whatsapp-button black-bordered-button"
                  onClick={handleWhatsAppRedirect}
                >
                <svg stroke="white" fill="#25d366" stroke-width="0" viewBox="0 0 512 512" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path d="M260.062 32C138.605 32 40.134 129.701 40.134 250.232c0 41.23 11.532 79.79 31.559 112.687L32 480l121.764-38.682c31.508 17.285 67.745 27.146 106.298 27.146C381.535 468.464 480 370.749 480 250.232 480 129.701 381.535 32 260.062 32zm109.362 301.11c-5.174 12.827-28.574 24.533-38.899 25.072-10.314.547-10.608 7.994-66.84-16.434-56.225-24.434-90.052-83.844-92.719-87.67-2.669-3.812-21.78-31.047-20.749-58.455 1.038-27.413 16.047-40.346 21.404-45.725 5.351-5.387 11.486-6.352 15.232-6.413 4.428-.072 7.296-.132 10.573-.011 3.274.124 8.192-.685 12.45 10.639 4.256 11.323 14.443 39.153 15.746 41.989 1.302 2.839 2.108 6.126.102 9.771-2.012 3.653-3.042 5.935-5.961 9.083-2.935 3.148-6.174 7.042-8.792 9.449-2.92 2.665-5.97 5.572-2.9 11.269 3.068 5.693 13.653 24.356 29.779 39.736 20.725 19.771 38.598 26.329 44.098 29.317 5.515 3.004 8.806 2.67 12.226-.929 3.404-3.599 14.639-15.746 18.596-21.169 3.955-5.438 7.661-4.373 12.742-2.329 5.078 2.052 32.157 16.556 37.673 19.551 5.51 2.989 9.193 4.529 10.51 6.9 1.317 2.38.901 13.531-4.271 26.359z"></path></svg>               
                &nbsp;Buy Now Via Whatsapp
              </button>


              <Dialog
                open={open}
                onClose={handlePopupClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title" className='unbounded'>Payment Closed</DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    The payment process was closed. Please try again if you wish to complete the payment.
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <button onClick={handlePopupClose} className='black-button' autoFocus>
                    Close
                  </button>
                </DialogActions>
              </Dialog>
            </div>
            
        </div>
      </div>

      
    </div>
    <Footer />
    </>
  );
}
